import { createAsyncThunk, createSlice } from "@reduxjs/toolkit"
import { handleAuthentication } from "@containers/App/reducer"
import { keysToCamel } from "@lib/snakeTocamel"

const initialState = {
    userData: null,
    transactionData: null,
    transactionLoading: false,
    error: null,
    isLoading: false,
    isFetched: false,
    hasMore: false,
}

export const transactionHistoryPageSlice = createSlice({
    name: "transactionHistoryReducer",
    initialState: initialState,
    reducers: {
        reset: () => initialState,
        toggleIsLoading: (state, action) => {
            state.isLoading = action.payload
        },
    },
    extraReducers: (builder) => {
        //handle asynchronous actions
        builder.addCase(fetchUserData.fulfilled, (state, action) => {
            state.isLoading = false
            state.isFetched = true
            state.error = false
            state.userData = keysToCamel(action.payload)
        }),
            builder.addCase(fetchUserData.pending, (state) => {
                state.isLoading = true
                state.isFetched = false
                state.error = false
            }),
            builder.addCase(fetchUserData.rejected, (state) => {
                state.isLoading = false
                state.error = true
                state.isFetched = false
            }),
            builder.addCase(fetchTransactionHistoryData.fulfilled, (state, action) => {
                state.transactionLoading = false
                state.isFetched = true
                state.error = false
                state.transactionData = keysToCamel(action.payload)
                state.hasMore = action.payload.meta.total_pages > action.payload.meta.page
            }),
            builder.addCase(fetchTransactionHistoryData.pending, (state) => {
                state.transactionLoading = true
                state.error = false
            }),
            builder.addCase(fetchTransactionHistoryData.rejected, (state) => {
                state.transactionLoading = false
                state.error = true
                state.isFetched = false
            }),
            builder.addCase(onLoadmoreTransaction.fulfilled, (state, action) => {
                state.isLoading = false
                state.isFetched = true
                state.error = false
                state.hasMore = action.payload.meta.total_pages > action.payload.meta.page
                state.transactionData.transactions = state.transactionData.transactions.concat(
                    keysToCamel(action.payload.transactions)
                )
            }),
            builder.addCase(onLoadmoreTransaction.rejected, (state) => {
                state.isLoading = false
                state.error = true
                state.isFetched = false
            })
    },
})

export const fetchUserData = createAsyncThunk(
    "transactionHistoryPageSlice/fetchUserData",
    async (_arg, { extra, rejectWithValue, dispatch }) => {
        const { api } = extra
        try {
            const res = await api.get(`/api/corporate/wallet/user_card_widget`)
            return Promise.resolve(res?.data)
        } catch (err) {
            if (err.status_code === 403 || err.status_code === 401) dispatch(handleAuthentication())
            return rejectWithValue(err.error)
        }
    }
)

export const onLoadmoreTransaction = createAsyncThunk(
    "transactionHistoryPageSlice/onLoadmoreTransaction",
    async (params, { extra, rejectWithValue }) => {
        const { api } = extra
        if (params.page_no < 0) {
            return Promise.reject({
                status_code: 500,
                data: "Page Number can't Be Negative",
            })
        }

        try {
            const res = await api.get(`/api/corporate/wallet/transactions_history`, { params })
            return Promise.resolve(res?.data)
        } catch (err) {
            return rejectWithValue(err.error)
        }
    }
)

export const fetchTransactionHistoryData = createAsyncThunk(
    "transactionHistoryPageSlice/fetchTransactionHistoryData",
    async (params, { extra, rejectWithValue }) => {
        const { api } = extra
        try {
            const res = await api.get(`/api/corporate/wallet/transactions_history`, { params })
            return Promise.resolve(res?.data)
        } catch (err) {
            return rejectWithValue(err.error)
        }
    }
)

export const transactionHistoryReducer = transactionHistoryPageSlice.reducer
export const { reset, toggleIsLoading } = transactionHistoryPageSlice.actions
